import { gql } from "@apollo/client"

export const MONEY_FIELDS = gql`
  fragment MoneyFields on Money {
    subunit
    formatted
    currencyCode
    subunitToUnit
  }
`
